import { GridItem } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const ImageContainer = styled(GridItem) `
  border-radius: ${({ theme }) => theme.borderRadius[100]};
  height: 12rem;
  overflow: hidden;
  position: relative;

  img {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  ${({ theme }) => theme.breakpoint.minWidth('sm')} {
    height: 20rem;
  }

  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    height: 32rem;
  }
`;
export const FactSloganOverlay = styled.div `
  position: absolute;
  border-radius: ${({ theme }) => theme.borderRadius[100]};
  z-index: 1;
  bottom: ${({ theme }) => theme.spacing[600]};
  left: ${({ theme }) => theme.spacing[600]};
  background-color: ${({ theme }) => theme.color.background.primary};
  padding: ${({ theme }) => theme.spacing[600]};

  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    width: 60%;
    max-width: 42rem;
  }
`;
//# sourceMappingURL=FAQ.styled.js.map